import React, { useEffect, useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectCurrentVariantCohort } from 'root-redux/selects/common'
import { getPathFromPageId } from 'helpers/getPathFromPageId'
import {
  selectTestEnvironmentQueryParam,
  selectUUID,
} from 'root-redux/selects/user'
import { useGetPageInfo } from 'hooks/useGetPageInfo'
import { goTo } from '../../browserHistory'

export const SubscribeFlow: React.FC = () => {
  const { search } = useLocation()
  const { currentVariantPageList } = useGetPageInfo()
  const cohort = useSelector(selectCurrentVariantCohort)
  const uuid = useSelector(selectUUID)
  const testEnvironmentQueryParam = useSelector(selectTestEnvironmentQueryParam)

  const firstPagePath = useMemo(
    () =>
      getPathFromPageId({
        pageId: currentVariantPageList[0].id,
        cohort,
        uuid,
        testEnvironmentQueryParam,
      }),
    [currentVariantPageList, cohort, uuid, testEnvironmentQueryParam],
  )

  useEffect(() => {
    const URLParams = new URLSearchParams(search)
    const uuidFromUrl = URLParams.get('uuid')

    if (!uuidFromUrl) {
      goTo(firstPagePath)
    }
  }, [search, firstPagePath])

  return <Outlet />
}
